import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "gm-avis-box" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://www.location-gardemeuble.fr/img/avatar-vide.jpg",
  alt: "",
  width: "46",
  height: "46"
}, null, -1)
const _hoisted_3 = { style: {"position":"relative","left":"50px","top":"2px"} }
const _hoisted_4 = { style: {"display":"block"} }
const _hoisted_5 = { style: {"text-transform":"capitalize"} }
const _hoisted_6 = {
  class: "stars-block",
  style: {"margin-left":"0.5em"}
}
const _hoisted_7 = { class: "grey" }
const _hoisted_8 = { style: {"margin-top":"0.3em"} }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { style: {"padding":"0 0.2em"} }, "-", -1)
const _hoisted_10 = { style: {"text-transform":"capitalize","font-size":"0.8em"} }
const _hoisted_11 = {
  key: 0,
  class: "no-mobile"
}
const _hoisted_12 = { style: {"position":"absolute","right":"430px","top":"15px","text-align":"right"} }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Accueil : ")
const _hoisted_14 = { class: "stars-block" }
const _hoisted_15 = { class: "grey" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Service : ")
const _hoisted_18 = { class: "stars-block" }
const _hoisted_19 = { class: "grey" }
const _hoisted_20 = { style: {"position":"absolute","right":"200px","top":"15px","text-align":"right"} }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Propreté : ")
const _hoisted_22 = { class: "stars-block" }
const _hoisted_23 = { class: "grey" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Qualité/Prix : ")
const _hoisted_26 = { class: "stars-block" }
const _hoisted_27 = { class: "grey" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.state.gm.avis.slice( 0, this.avis_shown ), (avis) => {
      return (_openBlock(), _createElementBlock("article", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("b", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(avis.name), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                  return _createVNode(_component_font_awesome_icon, {
                    key: index,
                    icon: "star"
                  })
                }), 64))
              ]),
              _createElementVNode("div", {
                class: "gold",
                style: _normalizeStyle({ width : ( avis.note / 5 * 100 ) + '%' })
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                  return _createVNode(_component_font_awesome_icon, {
                    key: index,
                    icon: "star"
                  })
                }), 64))
              ], 4)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("i", null, "\"" + _toDisplayString(avis.note_text) + "\"", 1),
            _hoisted_9,
            _createElementVNode("i", _hoisted_10, _toDisplayString((new Date( avis.date )).toLocaleDateString( 'fr-FR', {
                year  : 'numeric',
                month : 'long'
              } )), 1)
          ])
        ]),
        (this.store.getters.isDesktop)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("span", null, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                        return _createVNode(_component_font_awesome_icon, {
                          key: index,
                          icon: "star"
                        })
                      }), 64))
                    ]),
                    _createElementVNode("div", {
                      class: "gold",
                      style: _normalizeStyle({ width : ( avis.notes.accueil / 5 * 100 ) + '%' })
                    }, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                        return _createVNode(_component_font_awesome_icon, {
                          key: index,
                          icon: "star"
                        })
                      }), 64))
                    ], 4)
                  ])
                ]),
                _hoisted_16,
                _hoisted_17,
                _createElementVNode("span", null, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                        return _createVNode(_component_font_awesome_icon, {
                          key: index,
                          icon: "star"
                        })
                      }), 64))
                    ]),
                    _createElementVNode("div", {
                      class: "gold",
                      style: _normalizeStyle({ width : ( avis.notes.service / 5 * 100 ) + '%' })
                    }, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                        return _createVNode(_component_font_awesome_icon, {
                          key: index,
                          icon: "star"
                        })
                      }), 64))
                    ], 4)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("span", null, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                        return _createVNode(_component_font_awesome_icon, {
                          key: index,
                          icon: "star"
                        })
                      }), 64))
                    ]),
                    _createElementVNode("div", {
                      class: "gold",
                      style: _normalizeStyle({ width : ( avis.notes.proprete / 5 * 100 ) + '%' })
                    }, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                        return _createVNode(_component_font_awesome_icon, {
                          key: index,
                          icon: "star"
                        })
                      }), 64))
                    ], 4)
                  ])
                ]),
                _hoisted_24,
                _hoisted_25,
                _createElementVNode("span", null, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                        return _createVNode(_component_font_awesome_icon, {
                          key: index,
                          icon: "star"
                        })
                      }), 64))
                    ]),
                    _createElementVNode("div", {
                      class: "gold",
                      style: _normalizeStyle({ width : ( avis.notes.prix / 5 * 100 ) + '%' })
                    }, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                        return _createVNode(_component_font_awesome_icon, {
                          key: index,
                          icon: "star"
                        })
                      }), 64))
                    ], 4)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("p", null, _toDisplayString(avis.comment), 1)
      ]))
    }), 256)),
    (!this.store.state.avis_modal)
      ? _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => {this.avis_shown = this.avis_shown + 999;}),
          class: "button mob-100 black",
          style: {"display":"block","margin":"-0.4em auto 2em"}
        }, " Voir plus d'avis pour ce garde-meuble ", 512)), [
          [_vShow, this.avis_shown <= this.store.state.gm.avis.length]
        ])
      : _createCommentVNode("", true)
  ]))
}